const footerElements = document.querySelectorAll("[data-site-footer]");

async function loadPublicSiteConfig() {
  if (footerElements.length === 0) return;
  try {
    const response = await fetch("/api/public-config", {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    });
    if (!response.ok) return;
    const config = await response.json();
    const recordNumber = String(config.icpRecordNumber || "").trim();
    if (!recordNumber) return;
    const recordUrl = new URL(
      config.icpRecordUrl || "https://beian.miit.gov.cn/"
    );
    if (
      recordUrl.protocol !== "https:" ||
      recordUrl.hostname !== "beian.miit.gov.cn"
    ) {
      return;
    }
    for (const footer of footerElements) {
      const link = footer.querySelector("[data-icp-link]");
      if (!link) continue;
      link.textContent = recordNumber;
      link.href = recordUrl.href;
      footer.hidden = false;
    }
  } catch {
    // Local development may intentionally omit public deployment config.
  }
}

void loadPublicSiteConfig();
